import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { getAvailableImages, setURLParams, getImageSizeAndFormatParams } from '../../Helpers/imageHelper'
import MobileImagePreview from '../../components/ProductDetailPage/ImagePreview/mobile'
import DesktopImagePreview from '../../components/ProductDetailPage/ImagePreview/desktop'

const transformImages = (images) => {
  const [firstImage] = images
  const imgParams = getImageSizeAndFormatParams(firstImage)
  return images.map((image) => setURLParams(image, imgParams))
}

const ImagePreview = ({ hit, isMobile }) => {
  const { tags } = hit
  const { availableImages = [] } = hit.images
  const isWalmartExclusive = (Array.isArray(tags) && tags?.some((value) => value === 'exclusivo')) || false
  const backgroundPosition = '0% 0%'
  const [images, setImages] = useState([])

  useEffect(() => {
    const getValidImages = async () => {
      const transformedImages = transformImages(availableImages)
      const validImages = await getAvailableImages(transformedImages)
      setImages(validImages)
    }

    getValidImages()
  }, [availableImages])

  if (!isMobile) {
    return (
      <DesktopImagePreview
        hit={hit}
        images={images}
        walmartExclusive={isWalmartExclusive}
        backgroundPosition={backgroundPosition}
      />
    )
  }
  return <MobileImagePreview hit={hit} images={images} walmartExclusive={isWalmartExclusive} />
}

export default ImagePreview

ImagePreview.defaultProps = {
  hit: {},
  isMobile: false,
}

ImagePreview.propTypes = {
  isMobile: PropTypes.bool,
  hit: PropTypes.object,
}
